import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { BehaviorSubject, Subject } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class RealtimeService {
  private ewsChanged = new Subject<void>();
  ewsChanged$ = this.ewsChanged.asObservable();
  private socket: Socket;
  private orderFlowChanged = new Subject<void>();
  orderFlowChanged$ = this.orderFlowChanged.asObservable();
  private skuPricingChanged = new Subject<void>();
  skuPricingChanged$ = this.skuPricingChanged.asObservable();

  private _socketStatus$ = new BehaviorSubject<{ name: string; connected: boolean; id?: string; transport?: string; error?: any }>({
    name: 'main',
    connected: false
  });
  socketStatus$ = this._socketStatus$.asObservable();

  private _formResponses$ = new BehaviorSubject<any>([]);
    private _notificationAdded$ = new BehaviorSubject<any>([]);
    private _cuppingSessionUpdates$ = new BehaviorSubject<any>([]);
  formResponses$ = this._formResponses$.asObservable();
    notificationAdded$ = this._notificationAdded$.asObservable();
    cuppingSessionUpdates$ = this._cuppingSessionUpdates$.asObservable();

  constructor() {

    const url =
      environment.WS_URL === 'http://localhost:5150'
            ? 'http://localhost:5150'
        : 'https://dev-exp-hya7b3bfbmafhkbk.eastus2-01.azurewebsites.net';

    const opts = {
      transports: ['websocket'],      // force single transport (see note below)
      reconnection: true,
      reconnectionAttempts: 10,
      timeout: 20000
    };

    this.socket = io(url, opts);
    this.socket.on('ews-changed', () => this.ewsChanged.next());
    this.socket.on('order-flow-changed', () => this.orderFlowChanged.next());
    this.socket.on('sku-pricing-changed', () => this.skuPricingChanged.next());

    this.attachDebugHandlers(this.socket, 'main');


    // IMPORTANT: avoid stacking handlers if service is created twice
    this.socket.on('notifications-changed', () => this._notificationAdded$.next({refresh:true}));
    this.socket.off('notification-added');
    this.socket.on('notification-added', (payload) => {
      console.log('[main] Received notification-added event:', payload);
      const list = Array.isArray(payload) ? payload : [payload];
      list.forEach((n) => this._notificationAdded$.next(n));
    });

    // If you re-enable forms:
    this.socket.off('form-response');
    this.socket.on('form-response', (payload) => {
      console.log('[form] Received form-response event:', payload);
      this._formResponses$.next(payload);
    });

      this.socket.off('cupping-session-update');
      this.socket.on('cupping-session-update', (payload) => {
          this._cuppingSessionUpdates$.next(payload);
      })
  }

  private attachDebugHandlers(s: Socket, name: string) {
    // Connected
    s.on('connect', () => {
      console.log(`[${name}] ✅ connected`, { id: s.id, connected: s.connected, transport: s.io.engine.transport?.name });
      this._socketStatus$.next({ name, connected: true, id: s.id, transport: s.io.engine.transport?.name });
    });

    // Disconnected
    s.on('disconnect', (reason) => {
      console.warn(`[${name}] ⚠️ disconnected`, { reason, connected: s.connected });
      this._socketStatus$.next({ name, connected: false, id: s.id });
    });

    // Cannot connect / handshake fails
    s.on('connect_error', (err) => {
      console.error(`[${name}] ❌ connect_error`, err?.message ?? err, err);
      this._socketStatus$.next({ name, connected: false, error: err });
    });

    // Helpful reconnect signals (these exist in Socket.IO client)
    s.io.on('reconnect_attempt', (attempt) => console.warn(`[${name}] 🔁 reconnect_attempt`, attempt));
    s.io.on('reconnect_error', (err) => console.error(`[${name}] 🔁 reconnect_error`, err));
    s.io.on('reconnect_failed', () => console.error(`[${name}] 🛑 reconnect_failed`));
  }
}
